import { useNavigate } from 'react-router';

import DrawerBody from './DrawerBody';
import DrawerFooter from './DrawerFooter';
import { DrawerComponentProps } from './DrawerManager';
import UnitCheckInCard from 'src/components/fragments/UnitCheckInCard';
import ResidentsInUnit from 'src/components/units/ResidentsInUnit';
import useCareTypeFeatures from 'src/hooks/useCareTypeFeatures';
import { CheckIn, Resident, Unit } from 'src/store/sageAdminApi';

const DrawerName = 'Unit Details Drawer';
export interface UnitDetailDrawerProps extends DrawerComponentProps {
    unit: Unit & { checkIn?: CheckIn };
}

export default function UnitDetailDrawer(props: UnitDetailDrawerProps) {
    const { onClose, onNext, unit } = props;

    const navigate = useNavigate();

    const { getFeatures } = useCareTypeFeatures();
    const isCheckInEligible = getFeatures(unit?.careType).checkIns.isEnabled;

    return (
        <>
            {/* Scrolling Area */}
            <DrawerBody sx={{ pt: 8 }}>
                <ResidentsInUnit
                    unit={unit}
                    analyticsPrefix={DrawerName}
                    onResidentClick={(resident: Resident) => {
                        navigate(`/residents/resident/${resident?.id}`);
                        onClose();
                    }}
                />
            </DrawerBody>

            {/* Bottom Sticky Buttons */}
            {isCheckInEligible && (
                <DrawerFooter>
                    <UnitCheckInCard unit={unit} onNext={onNext} analyticsPrefix={DrawerName} />
                </DrawerFooter>
            )}
        </>
    );
}
